import React, {useState, useEffect} from 'react';
import Slider from '../Slider';
import parse from 'html-react-parser';
import Image from '../Image';
import Freezer from '../Freezer';
import FarmerBanner from '../FarmerBanner';
import Category from '../Category';
import RelatedProducts from '../RelatedProducts';
import RelatedRecipes from '../RelatedRecipes';
import MeatcutOverview from '../MeatcutOverview';
import RecipeHighlight from '../RecipeHighlight';
import ProductHighlight from '../ProductHighlight';
import Newsletter from '../Newsletter';
import NewsletterPopup from '../NewsletterPopup';
import BreedsOverview from '../BreedsOverview';
import Reviews from '../Reviews';
import {isNil} from 'lodash';
import {isJSONstring} from '../../../utils/storage';
import W from '../Word';


function LoadModule({data, product, filter, moduleData}) {
    const [moduleType, setModuleType] = useState();
    const [moduleConfig, setModuleConfig] = useState(null);
    const [items, setItems] = useState();
    
    //console.log(data);
    useEffect(() => {
        if(!isNil(data.config)){
            if(isJSONstring(data.config))
                setModuleConfig(JSON.parse(data.config));
            else
                setModuleConfig(data.config);
        }
        setModuleType(data.module);
        //console.log(moduleData);
    }, [data])


    return (
        <div>
            {data && moduleType == 'slider' &&
                <Slider data={data.slider_items} config={moduleConfig} />
            }
            {data && moduleType == 'text_box' &&
                <div className="container mt-40 module__text-box">
                    <div className="row">
                    <div className="col-12">
                        <h2>{data.title}</h2>
                        {data.body && parse(data.body)}
                    </div>
                    </div>
                </div>
            }
            {data && moduleType == 'html_box' &&
                <div className="module__html-box">
                    {data.body && parse(data.body)}
                </div>
            }
            {data && moduleType == 'freezer_size' &&
                <div className="module__freezer-size">
                    <Freezer config={moduleConfig} weight={product && product.shop_package_frontend_size} />
                </div>
            }
            {data && moduleType === 'animal_switch' &&
                <Category filter={filter} config={moduleConfig} />
            }
            {data && moduleType === 'farmer_banner' &&
                <FarmerBanner data={moduleData} />
            }
            {moduleData && moduleType === 'related_products' &&
                <RelatedProducts relatedType={moduleData.relatedType} relatedSlug={moduleData.relatedSlug} />
            }
            {moduleData && moduleType === 'related_recipes' &&
                <RelatedRecipes relatedType={moduleData.relatedType} relatedSlug={moduleData.relatedSlug} />
            }    
            {data && moduleType == 'related_meatcuts' &&
                <div className="module__meatcut">
                    <MeatcutOverview animalId={moduleConfig} />
                </div>
            }
            {data && moduleType == 'related_breeds' &&
                <div className="module__breeds">
                    <BreedsOverview items={data.items} />
                </div>
            }
            {data && moduleType == 'related_reviews' &&
                <div className="module__reviews">
                    <Reviews items={data.items} />
                </div>
            }
            {data && moduleType == 'recipe_highlight' &&
                <RecipeHighlight items={data.items} />
            }
            {data && moduleType == 'product_card' &&
                <ProductHighlight items={data.items} />
            }
            {data && moduleType == 'newsletter' && moduleConfig.position != 'popup' &&
                <Newsletter data={moduleConfig} />
            }
            {data && moduleType == 'newsletter' && moduleConfig.position == 'popup' &&
                <NewsletterPopup data={moduleConfig} />
            }
        </div>
    )

}

export default LoadModule
